<template>
    <div class="plan-forcast-update clearfix">
        <compWrapper title="Base Infomation" theme="primary">
            <compFormQuery
                col="1"
                class="margin-15 width-60per"
                ref="formbase"
                placeholder="--"
                :formdata="getBase"
                v-model="formData"
                :labelWidth="120"
            ></compFormQuery>
        </compWrapper>
        <compWrapper style="position: relative" :title="$t('global.common.operation_history', { defaultValue: '操作历史' })" theme="gray">
            <compLog :data="logList"></compLog>
            <Spin v-if="logLoading" fix></Spin>
        </compWrapper>
        <!-- <div class="margin-20 pull-right">
            <Button type="default" @click="$emit('on-close')">返回</Button>
        </div> -->
        <Spin v-if="loading" fix></Spin>
    </div>
</template>

<script>
import {
    HttpGetPlanParamDetail,
    HttpSysOpLog,
} from "@/service/purchase/purchase.js";
import mixin from "./mixin";
import { mapState, mapGetters } from "vuex";
export default {
    props: ["activeid"],
    mixins: [mixin],
    data() {
        return {
            id: this.activeid ? this.activeid : this.$route.query.id,
            loading: false,
            logLoading: false,
            formData: {},
            logList: [],
        };
    },
    mounted() {
        this.getDetail();
    },
    computed: {
        ...mapGetters("diction", ["getNewDifferentAllProductList"]),
        getBase() {
            return [
                {
                    label: "ERP SKU",
                    key: "erpSku",
                    render: (h) => {
                        let that = this;
                        function jumpToProduct() {
                            let productId = that.formData.productId;
                            let url = that.$router.resolve({
                                name: "allproductsUpdate",
                                params: { type: "query" },
                                query: { id: productId },
                            });
                            window.open(url.href, "_blank");
                        }

                        return (
                            <a onClick={jumpToProduct}>
                                {this.formData.erpSku}
                            </a>
                        );
                    },
                },
                {
                    label: this.$t('global.common.project', { defaultValue: "项目" }),
                    key: "lineId",
                    render: (h) => {
                        let productItem =
                            this.getNewDifferentAllProductList.filter(
                                (item) => {
                                    return item.value === this.formData.lineId;
                                }
                            )[0];
                        return (
                            <div>{productItem ? productItem.label : "--"}</div>
                        );
                    },
                },
                {
                    label: this.$t('erp.planparam.purchase_type', { defaultValue: "项目采购模式" }),
                    key: "purchaseType",
                    render: (h) => {
                        let purchaseItem = this.getProjectBuyList.filter(
                            (item) => {
                                return (
                                    item.value === this.formData.purchaseType
                                );
                            }
                        )[0];
                        return (
                            <div>
                                {purchaseItem ? purchaseItem.label : "--"}
                            </div>
                        );
                    },
                },
                {
                    label: this.$t('erp.product.product_status', { defaultValue: "产品状态" }),
                    render: (h) => {
                        let productItem = this.getProductStatusList.filter(
                            (item) => {
                                return (
                                    item.value === this.formData.productStatus
                                );
                            }
                        )[0];

                        return (
                            <div>{productItem ? productItem.label : "--"}</div>
                        );
                    },
                },
                {
                    label: this.$t('erp.product.saleslocation', { defaultValue: "销售定位" }),
                    render: (h) => {
                        let productItem = this.getSalesLocation.filter(
                            (item) => {
                                return item.value === this.formData.saleType;
                            }
                        )[0];

                        return (
                            <div>{productItem ? productItem.label : "--"}</div>
                        );
                    },
                },
                {
                    label: this.$t('erp.product.pruchas_status', { defaultValue: "补货状态" }),
                    render: (h) => {
                        let productItem = this.getReplenishmentStatus.filter(
                            (item) => {
                                return (
                                    item.value ===
                                    this.formData.replenishmentStatus
                                );
                            }
                        )[0];

                        return (
                            <div>{productItem ? productItem.label : "--"}</div>
                        );
                    },
                },
                {
                    label: "Planner",
                    key: "planner",
                },
                {
                    label: "Buyer",
                    key: "buyer",
                },
                {
                    label: "Order Cycle Time",
                    key: "orderCycle",
                },
                {
                    label: this.$t('erp.product.production_lead_time', { defaultValue: "生产提前期" }),
                    key: "productionCycle",
                },
                {
                    label: this.$t('erp.product.minimun_order_quantity', { defaultValue: "最小起订量" }),
                    key: "minQuantity",
                },
                {
                    label: this.$t('erp.planparam.target_inventory', { defaultValue: "目标库龄" }),
                    key: "inventory",
                },
                {
                    label: this.$t('erp.virtualstore.safeQuantity', { defaultValue: "安全库存" }),
                    key: "safetyStock",
                },
            ];
        },
    },
    methods: {
        async getDetail() {
            this.loading = true;
            this.logLoading = true;
            await HttpGetPlanParamDetail({
                id: this.id,
            })
                .then(
                    (res) => {
                        this.formData = res.data;
                    },
                    (err) => {
                        this.$VMessage.error(err.message);
                    }
                )
                .finally(() => {
                    this.loading = false;
                });
            await HttpSysOpLog({
                search: {
                    EQ_opDataId: this.id,
                    EQ_opModel: "Inventory_Plan",
                },
            })
                .then(
                    (res) => {
                        this.logList = res.data.content;
                    },
                    (err) => {
                        this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true,
                        });
                    }
                )
                .finally(() => {
                    this.logLoading = false;
                });
        },
    },
};
</script>

<style>
</style>
